import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';

import { CustomBlockingReason } from './CustomBlockingReason';
import { PaymentRequiredReason } from './PaymentRequiredReason';
import { RequiredDocumentReason } from './RequiredDocumentReason';
import { RequiredFormReason } from './RequiredFormReason';
import { WaiverRequiredReason } from './WaiverRequiredReason';
import { BlockingReasonVariant, CheckinBlockerUser } from './_types';

export function BlockingReasonList({
  blockers,
  getBlockerActions,
  userId,
  variant = 'checkin',
}: {
  blockers: CheckinBlockerUser['blockers'];
  getBlockerActions?: (
    blocker: CheckinBlockerUser['blockers'][number]
  ) => ButtonPropsWithLabel[] | undefined;
  userId: string;
  variant?: BlockingReasonVariant;
}) {
  return (
    <Stack spacing={1.5} sx={{ width: '100%' }}>
      {blockers.map((blocker, index) => {
        const key = `${blocker.type}-${index}`;
        switch (blocker.type) {
          case 'paymentRequired':
          case 'billing_blocked':
            return (
              <PaymentRequiredReason
                key={key}
                userId={userId}
                actions={getBlockerActions?.(blocker)}
                resolved={blocker.resolved}
                variant={variant}
              />
            );
          case 'formsBlocked':
          case 'forms_blocked':
            return (
              <RequiredFormReason
                key={key}
                actions={getBlockerActions?.(blocker)}
                resolved={blocker.resolved}
                variant={variant}
              />
            );
          case 'check_in_blocked':
            return (
              <CustomBlockingReason
                key={key}
                message={blocker.message}
                actions={getBlockerActions?.(blocker)}
                variant={variant}
              />
            );
          case 'waiver_required':
            return <RequiredDocumentReason key={key} actions={getBlockerActions?.(blocker)} />;
          // LEGACY: camelCase `waiverRequired` is not emitted by the backend;
          // kept only for the legacy placeholder UI. See WaiverRequiredReason.
          case 'waiverRequired':
            return (
              <WaiverRequiredReason
                key={key}
                _userId={userId}
                actions={getBlockerActions?.(blocker)}
                variant={variant}
              />
            );
          default:
            return (
              <CustomBlockingReason
                key={key}
                title={blocker.title}
                message={blocker.message}
                actions={getBlockerActions?.(blocker)}
                variant={variant}
              />
            );
        }
      })}
    </Stack>
  );
}
